<template>
  <!-- 审核 -->
  <vForm class="clearfix" v-model="formData" labelWidth="150" ref="dataForm" style="text-align: left;">
        <vFormItem prop="radioType" label=" " :rules='required'>
                <RadioGroup v-model="formData.extra_audit_action">
                    <Radio :label="1">{{$t('fbb.inbound.pass_audit', { defaultValue: '审核通过' })}}</Radio>
                    <Radio :label="2">{{$t('fbb.inbound.back_audit', { defaultValue: '审核拒回' })}}</Radio>
                </RadioGroup>
        </vFormItem>
      <div class="access" v-if="formData.extra_audit_action === 1">
           <vCol span="24">
                <vFormItem :label="$t('fbb.headlogistics.logistics_type', { defaultValue: '发运类型' })" class="width-75per" prop="transport_type" :rules="required">
                    <vSelect v-model="formData.logistics_type">
                        <vOption v-for="item in logisticsTypeList" :key="item.key" :value="item.value">{{item.label}}</vOption>
                    </vSelect>
                </vFormItem>
          </vCol>
          <vCol span="24">
                <vFormItem :label="$t('fbb.headlogistics.ship_port', { defaultValue: '发运港' })" class="width-75per" prop="ship_port_id" :rules="required">
                    <vSelect v-model="formData.ship_port_id" @on-change="getPortName" filterable>
                        <vOption v-for="item in getSystemPortList" :key="item.key" :value="item.value">{{item.label}}</vOption>
                    </vSelect>
                </vFormItem>
          </vCol>
          <vCol span="24">
                <vFormItem :label="$t('fbb.headlogtics.importer', { defaultValue: '进口商' })" class="width-75per" prop="importer_id" :rules="required" filterable>
                    <vSelect v-model="formData.importer_id" filterable @on-change="getImporterName">
                        <vOption v-for="item in getImporterList" :key="item.key" :value="item.value">{{item.label}}</vOption>
                    </vSelect>
                </vFormItem>
          </vCol>
          <vCol span="24">
              <vFormItem label="Bound" class="width-75per" prop="bound" :rules="required">
                  <vInput v-model="formData.bound"></vInput>
              </vFormItem>
          </vCol>
          <vCol span="24" v-if="originData.buyerRemark!==''&&originData.buyerRemark!==null">
                <vFormItem :label="$t('global.common.buyer', { defaultValue: '买方备注' })" class="width-75per">
                    <span>{{ originData.buyerRemark }}</span>
                </vFormItem>
          </vCol>
          <vCol span="24">
                <vFormItem :label="$t('global.common.notes', { defaultValue: '备注' })" class="width-75per">
                    <vTextarea v-model="remark"></vTextarea>
                </vFormItem>
          </vCol>
          <vCol span="24">
                <vFormItem :label="$t('fbb.headlogistics.attach_upload', { defaultValue: '附件上传' })" class="width-75per">
                    <div class="upload">
                        <div class="upload-item" v-for="(item, index) in attachments" :key="item.key">
                            <div class="filename">{{item.fileName}}</div>
                            <div><Icon class="close" size="13" type="md-close" @click="clearUpload(index)" /></div>
                        </div>
                    </div>
                    <vButton theme="success" @click="importFile">{{$t('global.common.add', { defaultValue: '添加' })}}</vButton>
                </vFormItem>
          </vCol>
      </div>
      <div class="refuse" v-else>
        <vCol span="24">
            <vFormItem :label="$t('global.common.notes', { defaultValue: '备注' })" class="width-75per">
                <vTextarea v-model="remark"></vTextarea>
            </vFormItem>
        </vCol>
      </div>
      <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compUpload
                v-bind="getFileProps"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
      <div class="pull-right">
          <vButton style="margin: 10px 5px;" theme="primary" :disabled="isSubmit" @click="submit">{{$t('global.common.confirm', { defaultValue: '确定' })}}</vButton>
          <vButton style="margin: 10px 5px;" @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
      </div>
  </vForm>
</template>
<script>
import { mapGetters } from 'vuex'
import mixinlist from '../mixin'
import { HttpUpdateLogistics } from "@/service/headlogistics"
export default {
    props: ['originData', 'operateType', 'isSub', 'childId'],
    mixins: [mixinlist],
    components: {
		compUpload: () => import("@components/templates/upload")
    },
    data () {
        return {
            importerItem: {
                value: '',
                label: ''
            },
            formData: {
                extra_audit_action: 1,
            },
            remark: '',
            attachments: [],
            required: [{
                required: true,
                message: this.$t('global.common.information_empty', { defaultValue: "该信息不能为空,请填写" })
            }],
            operate: {
                show: false,
                title: this.$t('fbb.headlogistics.attach_upload', { defaultValue: '附件上传' }),
                data: {}
            },
            isSubmit: false
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getImporterList', 'getSystemPortList']),
        getFileProps() {
			return {
				action: process.env.VUE_APP_APIURL_UC + '/api/v1/BizAttach/uploadFile',
				name: "multipartFile",
				data: {
                    srcLabel: this.originData.id,
					model: 'logistics',
                    type: 'other',
				}
			}
		},
    },
    methods: {
        getImporterName () {
            this.formData.importer_name = this.getImporterList.filter(item => {
                return this.formData.importer_id === item.value
            })[0].label
        },
        getPortName () {
            this.formData.ship_port = this.getSystemPortList.filter(item => {
                return this.formData.ship_port_id === item.value
            })[0].label
        },
        importFile () {
            this.operate.show = true
        },
        clearUpload (index) {
            this.attachments.splice(index, 1)
        },
        aaasuccess(res) {
            this.cancelUpload()
            this.upload = res.data
            this.attachments.push({
                fileName: this.upload.entity.filename,
                fileUrl: this.upload.entity.genUrl
            })
        },
        cancelUpload() {
            this.operate.show = false;
        },
        success () {
            this.$emit('on-success')
            this.$emit('on-close')
        },
        cancel () {
            this.$emit('on-close')
        },
        checkLogistics () {
            let flag = true
            // 直达
            if (this.formData.logisticsType === 'through') {
                let testArr = []
                this.originData.subLogisticsHeadParams.map(item => {
                    testArr.push(item.warehouseCode)
                })
                if (new Set(testArr).size > 1) {
                    flag = false
                }
            }
            return flag
        },
        async submit () {
            if (this.isSubmit) return
            let flag = true
            await this.$refs.dataForm.validate(valid => {
                if (!valid) {
                    this.$VMessage.error(this.$t('fbb.headlogistics.info_empty', { defaultValue: '必填项不能为空' }))
                    flag = false
                }
            })
            if (!flag) return
            // 拒回时不用参数
            if (this.formData.extra_audit_action === 2) {
                    this.formData = {}
            }
            // if (!valid) return this.$VMessage.error('请填写必填项');
            if (!this.checkLogistics()) return this.$VMessage.error(this.$t('fbb.headlogistics.error_tip', { defaultValue: '直达单据目的仓必须一致！' }))
            this.isSubmit = true
            await HttpUpdateLogistics({
                headId: this.originData.id,
                isSub: this.isSub ? true : false,
                // 审核拒回的type为50
                type: this.formData.extra_audit_action === 1 ? this.operateType : 50,
                content: {
                    ...this.formData
                },
                attachments: this.attachments,
                remark: this.remark
            }).then(res => {
                this.$VMessage.success(res.message)
                this.success()
            }, err => {
                this.$VMessage.error(err.message)
            })
            this.isSubmit = false
        }
    }
}
</script>

<style lang="scss" scoped>
.upload-item {
    display: flex;
    color: #3399ff;

    .filename {
        width: 100%;
        overflow:hidden;
        white-space:nowrap;
        text-overflow: ellipsis;
    }

    .close {
        margin-left: 5px;
        &:hover {
            color: red;
            cursor: pointer;
        }
    }
}
</style>
